import { useTranslation } from "react-i18next";
import { FiCheck } from "react-icons/fi";
import { planNameKey } from "../../../../Common/Utils/dueDiligencePlans";
import {
  Card,
  CardHeader,
  PlanBadge,
  IncludedInPlanTag,
  PlanName,
  RenewalInfo,
  FeaturesSection,
  FeatureItem,
  FeatureIcon,
} from "./Styles";

interface CopilotIncludedInPlanProps {
  planLookupKey: string;
}

const FEATURE_KEYS = ["unlimitedQueries", "documentAnalysis"] as const;

export const CopilotIncludedInPlan = ({ planLookupKey }: CopilotIncludedInPlanProps) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader style={{ alignItems: "center", marginBottom: 0 }}>
        <PlanBadge style={{ marginBottom: 0 }}>{t("pricing.subscriptionContent.copilotPlan.badge")}</PlanBadge>
        <IncludedInPlanTag>{t("pricing.subscriptionContent.copilotIncluded.tag")}</IncludedInPlanTag>
      </CardHeader>
      <PlanName style={{ marginTop: "0.75rem" }}>{t("pricing.subscriptionContent.copilotIncluded.title")}</PlanName>
      <RenewalInfo>
        {t("pricing.subscriptionContent.copilotIncluded.description", { plan: t(planNameKey(planLookupKey)) })}
      </RenewalInfo>
      <FeaturesSection style={{ marginTop: "1rem" }}>
        {FEATURE_KEYS.map((key) => (
          <FeatureItem key={key}>
            <FeatureIcon>
              <FiCheck />
            </FeatureIcon>
            <span>{t(`pricing.subscriptionContent.copilotIncluded.features.${key}`)}</span>
          </FeatureItem>
        ))}
      </FeaturesSection>
    </Card>
  );
};
